/*
 * ConfirmationReducer
 *
 * The reducer takes care of our data. Using actions, we can change our application state.
 * To add a new action, add it to the ACTION_HANDLERS object.
 */

// Actions
const BOOKING_SUCCESS = 'app/Confirmation/BOOKING_SUCCESS';

// The initial state of the App
const initialState = {
  hotelReservation: null
};

// Action Handlers
const ACTION_HANDLERS = {
  [BOOKING_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      hotelReservation: action.payload
    })
};

// Action Creators
export function bookingSuccess(hotelReservation) {
  return {
    type: BOOKING_SUCCESS,
    payload: hotelReservation
  };
}

// Reducer
export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
